// Filters or pipes
import Vue from "vue";

Vue.filter('string_limit', function (value , limit = 20   , preceding = '...' ) {

    if (value)
    {
        return value.length > limit ? value.substr( 0 ,  limit ) + preceding : value;
    }


    return value;

});

Vue.filter('model', function (value , limit = 20   , preceding = '...' ) {

    if (value)
    {
        return value.replace(/App\\/, '');
    }

    return value;

});

Vue.filter('account', function (value) {

    let accounts = {
        "78" : "AC_ECOCASH_WALLET",
        "107" : "AC_ZESA_TOKEN_SUSPENSE",
        "81" : "AC_ZB_ZESA",
        "127" : "AC_STRIPE_WALLET",
        "126" : "AC_PROMOTIONAL_COSTS",
        "125" : "AC_COMMISSION_RECEIVABLE",
        "94" : "AC_SALES_COMMISSION",
        "108" : "AC_NETONE_AIRTIME_SUSPENSE",
        "114" : "AC_NETONE_FLOAT",
        "119" : "AC_NETONE_AGENT_COMMISSION",
        "118" : "AC_NETONE_COMMISSION",
        "120" : "AC_AGENT_COMMISSION",
        "109" : "AC_ECONET_AIRTIME_SUSPENSE",
        "113" : "AC_ECONET_FLOAT",
        "123" : "AC_ECONET_AIRTIME_COMMISSION",
        "111" : "AC_ECONET_AIRTIME_DEFERRED_REVENUE",
        "129" : "AC_PROMOTIONAL_COSTS_ECONET",
        "130" : "AC_PROMOTIONAL_COSTS_NETONE",
        "100" : "AC_BANK_CHARGES",
        "122" : "AC_ECONET_AIRTIME_COMMISSION_AGENTS",
        "148" : "AC_MANUAL_SUSPENSE_ACCOUNT",
        "131" : "AC_STEWARD_BANK_ACCOUNT",
        "154" : "AC_ECONET_USD_AIRTIME_DEFERRED_REVENUE",
        "155" : "AC_ECONET_USD_AIRTIME_COMMISSION",
    };

    if (accounts[value])
    {
        return accounts[value];
    }

    return value;

});

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(value);
});

Vue.filter('toCurrencyNumber', function (value) {
    if (value)
    {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return value;
});
